import React, { useState, useEffect } from "react";
import CustomModal from "../customModal";
import RecalculationTriggerForm from "./recalculationTriggerForm";
const defaultFilters = {
    groupId: null,
    companyId: null,
    siteId: null,
    categoryId: null,
    subcategoryId: null,
    trackedItemId: null,
    categoryOption: null,
    subcategoryOption: null,
    trackedItemOption: null,
};
const RecalculationTriggerModal = ({ modalVisibilty, closeModel, selectedSite, selectedCompany, selectedGroup, }) => {
    const [filters, setFilters] = useState(defaultFilters);
    useEffect(() => {
        if (!modalVisibilty) {
            setFilters(defaultFilters);
            return;
        }
        if (selectedSite) {
            setFilters(Object.assign(Object.assign({}, defaultFilters), { groupId: selectedSite.groupId, companyId: selectedSite.companyId, siteId: selectedSite.id }));
        }
        else if (selectedCompany) {
            setFilters(Object.assign(Object.assign({}, defaultFilters), { groupId: selectedCompany.groupId, companyId: selectedCompany.companyId }));
        }
        else if (selectedGroup) {
            setFilters(Object.assign(Object.assign({}, defaultFilters), { groupId: selectedGroup.groupId }));
        }
    }, [modalVisibilty, selectedSite, selectedCompany, selectedGroup]);
    const handleApplyFilter = (_filter) => { };
    return (React.createElement(CustomModal, { visible: modalVisibilty, onCancel: closeModel, maskClosable: false, destroyOnClose: true, footer: null, width: "450px", title: ["Recalulation Trigger"] }, modalVisibilty && (React.createElement(RecalculationTriggerForm, { groupOptionValues: filters, onChangeGroupOptions: setFilters, onApply: handleApplyFilter }))));
};
export default RecalculationTriggerModal;
